const VOICE_RECORD_AI_URL =
  import.meta.env.VITE_VOICE_RECORD_AI_URL || '/api/ai/voice-record';

async function postVoiceRecordAi(payload) {
  const res = await fetch(VOICE_RECORD_AI_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(res.ok ? 'Invalid AI response' : `AI request failed (${res.status})`);
  }
  if (!res.ok) throw new Error(data.error || `AI request failed (${res.status})`);
  return data;
}

/** Transcribe student audio via Portal gateway (Gemini multimodal / AI_OCR_MODEL). */
export async function describeVoiceRecording(audioUrl) {
  const data = await postVoiceRecordAi({ action: 'describe', audioUrl });
  return {
    transcript: String(data.transcript || '').trim(),
    model: data.model || null,
  };
}

/** Mark grammar/vocab mistakes as [wrong/correct], keeping the student's wording. */
export async function markVoiceRecordingMistakes(transcript) {
  const data = await postVoiceRecordAi({ action: 'mark_mistakes', transcript });
  return String(data.marked || '').trim();
}
